'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var cartConfirmationComponent = exports.cartConfirmationComponent = {
    template: require('./confirmation.html'),
    bindings: {
        disabledSellers: '<',
        orders: '<'
    },
    controllerAs: 'vm',
    controller: ["common", "gettextCatalog", "authService", "config", "$stateParams", "userService", "Analytics", function controller(common, gettextCatalog, authService, config, $stateParams, userService, Analytics) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.getDownloadUrl = getDownloadUrl;
        vm.ordersWithDeliveryDate = [];
        vm.ordersWithoutDeliveryDate = [];
        vm.mail = null;
        vm.user = null;

        function init() {
            common.navigationMenu.clearActiveMenu();
            common.setTitle(gettextCatalog.getString('Order confirmation'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/cart/confirmation', gettextCatalog.getString('Order confirmation'));

            splitArrayByDeliveryDate();
            userService.getMyAccount().then(function (u) {
                vm.mail = u.mail;
                vm.user = u;
            });
        }

        function splitArrayByDeliveryDate() {
            vm.orders.forEach(function (o) {
                if (o.deliveryDate === null) {
                    vm.ordersWithDeliveryDate.push(o);
                } else {
                    vm.ordersWithoutDeliveryDate.push(o);
                }
            });
        }

        function getDownloadUrl(orderId) {
            return config.webApiBaseUrl + ('report/orderDetail/' + orderId + '?lang=' + $stateParams.language + '&access_token=' + authService.accessToken);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/checkout/confirmation.js
// module id = 908
// module chunks = 0